const BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, '') || '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

class ExtensionService {
  async fetchExtension(extensionId) {
    try {
      const token = localStorage.getItem('session_token');
      if (!token) {
        throw new Error('Not authenticated');
      }

      const response = await fetch(`${API}/extension/${encodeURIComponent(extensionId)}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          ...(localStorage.getItem('active_exten')
            ? { 'X-Active-Exten': localStorage.getItem('active_exten') }
            : {}),
        },
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        const detail = errorBody.detail || response.statusText;
        throw new Error(`Extension request failed: ${detail}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching extension:', error);
      throw error;
    }
  }
}

export default new ExtensionService();
